import React, {useMemo} from "react";
import styled, {useTheme} from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 4px;
`;

const ListItemWithoutBorder = styled.button`
     appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  width: 32px;
  height: 32px;
  aspect-ratio: 1;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  background-color: ${props => {
    let color = 'transparent';
    if (props.selected) color = props.theme.color.gray_200;
    return color;
}};
  color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.selected) color = props => props.theme.color.dark_100;
    return color;
}};

  &:hover {
    background-color: ${props => {
    let color = props.theme.color.white_200;
    if (props.selected) color = props.theme.color.gray_200;
    return color;
}};
  } 
`;

const ListItem = styled(ListItemWithoutBorder)`

  border: ${props => {
    let border = '1px';
    if (props.selected) border = '1px';
    return border;
}} solid ${props => props.theme.color.default_border_color};
`;


const EmptyDotBox = styled.div`
  width: 32px;
  height: 32px;
  aspect-ratio: 1;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  align-items: center; 
  gap: 3.8px;
`;
const Dot = styled.div`
  width: 2.8px;
  height: 2.8px;
  border-radius: 100%;
  background-color: #33363D;
`;

const CustomClanDetailNavigator = ({
                                       currentPage,
                                       lastPage,
                                       onClickNext,
                                       onClickPrev,
                                       onClickToEnd,
                                       onClickToFist,
                                       onClickGoToPage
                                   }) => {
    const theme = useTheme();
    const visiblePageList = useMemo(() => {
        const BASE_LENGTH = 10;
        const startNumber = Math.floor((currentPage - 1) / 10) * 10;
        let listLength = BASE_LENGTH;
        if (BASE_LENGTH + startNumber > lastPage) {
            listLength = lastPage - startNumber;
        }
        if (listLength > 0) {
            return Array.from(new Array(listLength), (_, index) => 1 + index + startNumber);
        }
        return [];
    }, [currentPage, lastPage]);


    return (
        <Wrapper className={'w-full flex justify-center items-center'}>
            <ListItemWithoutBorder onClick={onClickToFist}>
                <img src={`${theme.icon.path}/connect/chevron_fast_backward.svg`} width={24} height={24} alt={''}/>
            </ListItemWithoutBorder>
            <ListItemWithoutBorder onClick={onClickPrev}>
                <img src={`${theme.icon.path}/connect/chevron_backward.svg`} width={24} height={24} alt={''}/>
            </ListItemWithoutBorder>
            {visiblePageList.map((data) => {
                return (
                    <ListItem key={"list" + data} selected={data === currentPage}
                              onClick={() => onClickGoToPage(data)}>
                        {data}
                    </ListItem>
                )
            })}
            <ListItemWithoutBorder onClick={onClickNext}>
                <img src={`${theme.icon.path}/connect/chevron_forward.svg`} width={24} height={24} alt={''}/>
            </ListItemWithoutBorder>
            <ListItemWithoutBorder onClick={onClickToEnd}>
                <img src={`${theme.icon.path}/connect/chevron_fast_forward.svg`} width={24} height={24} alt={''}/>
            </ListItemWithoutBorder>
        </Wrapper>
    );
};


export default CustomClanDetailNavigator;